export type Config = {
  footer: { showOnCheckIn: boolean },
  steps: { allowUpdatesBeforeCheckIn: boolean }
}

export const CONFIG: Config = {
  footer: { showOnCheckIn: false },
  steps: { allowUpdatesBeforeCheckIn: true }
}